<app-dialog
    class="dialog"
    header="Receive Compound"
    [show]="true"
    [hasControls]="true"
    saveBtnText="Receive"
    [hideControlsDivider]="true"
    (save)="submitForm()"
    (cancel)="cancel.emit()"
    (onCancelKeyDown)="lot.focusInput()"
    (onSubmitKeyDown)="lot.focusInput()"
    #dialog
>
    <div class="flex flex-col" [class.hidden]="!compoundFromArray?.length">
        <div [formGroup]="form" class="controls-container">
            <app-input 
                label="Custom Lot #"
                formControlName="lot"
                placeholder="0V3124"
                #lot
            ></app-input>
            <app-datepicker-input label="Expiration Date"
                formControlName="expirationDate"
                iconName="icon-date-picker"
                (inputTabKeyDown)="transactionDatePicker.focusInput()"
                (afterPickerClosed)="transactionDatePicker.focusInput()"
                #expirationDate
            ></app-datepicker-input>
            <app-datepicker-input [tabInd]="0"
                class="ml-[8px]"
                label="Transaction Date/Time"
                pickerType="both"
                formControlName="transactionDateDisplayValue"
                (dateTimeChange)="dateTimeChanged($event)"
                (inputTabKeyDown)="compoundTable.focusInput(0)"
                [dateMax]="now()"
                calendarPosition="right"
                #transactionDatePicker>
            </app-datepicker-input>
        </div>
        <div>
            <app-generic-write-table
                [formArray]="compoundFromArray" [columns]="compoundColumns"
                [useDefaultLocationChangeHandler]="true"
                addItemWording="+ Add Ingredient"
                [canAddNewItem]="!ingredientsFormArray?.length"
                (addNdc)="addIngredientMode = true"
                [excludeLocations]="[dmgExpLocationId]"
                (onLastNumberInputKeyupEnter)="handleCompoundTabbing()"
                (onLastInputKeydownTab)="handleCompoundTabbing()"
                [addNewItemAlwaysEnabled]="true"
                [activityType]="ActivityTypesEnum.Received"
                #compoundTable
            >
            </app-generic-write-table>
            <div class="ingredients-container" *ngIf="ingredientsFormArray?.length">
                <span>Ingredients</span>
                <app-generic-write-table
                    [formArray]="ingredientsFormArray" [columns]="ingredientColumns"
                    [useDefaultLocationChangeHandler]="true"
                    addItemWording="+ Add Ingredient"
                    adNdcClasses="!pt-0"
                    (onLastNumberInputKeyupEnter)="handleIngredientsTabbing()"
                    (onLastInputKeydownTab)="handleIngredientsTabbing()"
                    (addNdc)="addIngredientMode = true"
                    (rowDeleted)="handleIngredientDeletedSideEffect($event)"
                    (locationChosen)="ingredientLocationChosen($event)"
                    [template]="buttonWaste"
                    [canAddNewItem]="false"
                    [useDefaultLocationChangeHandler]="true"
                    #ingredientsTable
                >
                </app-generic-write-table>

                <button class="add-new-ndc"
                    (click)="addIngredientMode = true" 
                    [disabled]="ingredientsFormArray.invalid"
                >+ Add Ingredient
                 </button>

                <ng-template #buttonWaste let-control let-i="index">
                    <app-button styleClass="settings" [class.hidden]="control?.controls?.count.invalid || control?.controls?.hasWastedIngredients?.value"
                        subStyle="blue"
                        icon="icon-trash-active"
                        text="Waste"
                        [minWidth]="80"
                        (clicked)="openWasteDialog(control.value)"
                    ></app-button>
                    <app-button styleClass="settings" [class.hidden]="control?.controls?.count.valid || control?.controls?.hasWastedIngredients?.value"
                        subStyle="white-light-text"
                        icon="icon-trash-inactive"
                        text="Waste"
                        [minWidth]="80"
                        [disabled]="true"
                    ></app-button>

                    <app-button class="waste-green" [class.hidden]="!control?.controls?.hasWastedIngredients?.value"
                        styleClass="settings"
                        subStyle="green"
                        customClasses="cursor-default"
                        icon="icon-check-mark-green"
                        animateClass="none"
                        text="Waste"
                        [minWidth]="80"
                    >
                        <img src="assets/icons/icon-close-circle-blue.svg" alt="asc"
                            class="animation-focus-default"
                            (click)="removeWaste(control.value)"
                        />
                    </app-button>
                </ng-template>
            </div>
        </div>
    </div>
</app-dialog>

<app-dialog *ngIf="addCompoundNdcMode || !compoundFromArray.length"
    [show]="true"
    [header]="'Select Compound'"
    [hasControls]="true"
    (cancel)="cancel.emit()"
    [hideSaveButton]="true"
    [hideControlsDivider]="true"
    [minWidth]="780"
>

    <app-input-search-scanner 
        class="scanner"
        [autofocus]="true"
        (optionSelected)="compoundSelected($event)"
        [placeholder]="'Scan barcode (Or search drug name or NDC)'"
        [label]="'What compound do you want to receive?'"
        [limitDrugSearchToPharmacy]="false"
        [isCustomDrugSearch]="true"
        #searchScanner
    ></app-input-search-scanner>
</app-dialog>

<app-dialog *ngIf="addIngredientMode"
    [show]="true"
    [header]="'Add Ingredient'"
    [hasControls]="true"
    (cancel)="addIngredientMode = false"
    [hideSaveButton]="true"
    [hideControlsDivider]="true"
    [minWidth]="780"
    >
    <app-input-search-scanner 
        class="scanner"
        [autofocus]="true"
        (optionSelected)="ingredientSelected($event)"
        [placeholder]="'Scan barcode (Or search drug name or NDC)'"
        [label]="'What drug do you want to use for compounding?'"
        [isInventory]="true"
        [limitDrugSearchToPharmacy]="true"
        [singleLocationResult]="true"
        [locationsToExclude]="getLocationsToExclude()"
        #searchScanner
    ></app-input-search-scanner>
</app-dialog>

<app-destroy-ingredient-dialog *ngIf="wasteIngredientDialog"
    [ndcToWaste]="wasteDialogInputData$ | async"
    (submit)="ingredientDestroyed($event)"
    (cancel)="wasteIngredientDialog = false"
>
</app-destroy-ingredient-dialog>
